import request from '@/utils/inlayRequest'


//查询站点
export function tabBaseCompanyEntity(query) {
  return request({
    url: '/tab-base-company-entity/getCompanyListTest',
    method: 'get',
    headers: {"Content-Type": "application/json; charset=UTF-8",token:query.token},
    params:query,
  })
}


//查询站点
export function StatisticsDeliveryQuantity(token,data) {
    return request({
      url: '/tab-business-collect-entity/getSupplierCollectInfo',
      method: 'get',
      headers: {"Content-Type": "application/json; charset=UTF-8",token:token},
      params: data,
    })
  }

//查询站点
export function selectAllProductAndType({token,groupId}) {
  return request({
    url: '/tab-base-product-type-entity/selectAllProductAndType',
    method: 'get',
    headers: {"Content-Type": "application/json; charset=UTF-8",token:token},
    params: {
      groupId,
      pageCount:1,
      pageSize:100
    },
  })
}

//出库统计
export function OutboundStats(token,data) {
  
  return request({
    url: '/tab-base-stock-in-out-entity/OutboundStats',
    method: 'post',
    headers: {"Content-Type": "application/json; charset=UTF-8",token:token},
    data: data,
  })
}

//集团品类选择框
export function productSelectList(token) {
  
  return request({
    url: '/tab-base-group-product-category-entity/selectList',
    method: 'get',
    headers: {"Content-Type": "application/json; charset=UTF-8",token:token},
    params: {},
  })
}



// WEBPACK FOOTER //
// ./src/api/inlayApi.js